import React from 'react';
import { radiansToDegrees, reverseDegrees } from '../..';
export const ReverseRotate = ({ rotateY = 0, rotateX = 0, angle, gProps, children }) => (React.createElement("g", { transform: reverseRotateTransform(rotateX, rotateY, angle), ...gProps }, children));
export const reverseRotateTransform = (x, y, angle) => {
    const degrees = reverseDegrees(radiansToDegrees(angle));
    return degrees % 360 ? `rotate(${degrees} ${x} ${y})` : '';
};
//# sourceMappingURL=reverse-rotate.js.map